export interface DeviceLocationData {
    lat: number
    lng: number
    speed: number
    heading: number
    accuracy: number | null
    movement_type: string
}

export async function getDeviceLocation(): Promise<DeviceLocationData | null> {
    return null
}
